<template>
    <div class="nasabah">
        <p class="title">Verifikasi Nasabah</p>
        <div class="content">
            <div class="table-responsive">
                <table class="table table-striped table-bordered" id="my-table">
                    <thead>
                        <tr>
                            <!-- <th>No</th> -->
                            <th>Nama Lengkap</th>
                            <th>Tempat/Tanggal Lahir</th>
                            <th>Status Kewarganegaraan</th>
                            <th>No Telepon</th>
                            <th>NPWP</th>
                            <th>No Identitas</th>
                            <th class="action">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, i) in paginate" :key="i">
                            <td>{{ data.personal_data[0].full_name }}</td>
                            <td>{{ data.personal_data[0].place_of_birth }}, {{ data.personal_data[0].birthday | formatDate }}</td>
                            <td>{{ data.personal_data[0].citizenship }}</td>
                            <td>{{ data.personal_data[0].phone_number }}</td>
                            <td>{{ data.personal_data[0].npwp }}</td>
                            <td>{{ data.personal_data[0].identity_owner }}</td>
                            <td>
                                <router-link :to="'/nsb-detail/' + data._id"><button type="button" class="buttons btn-info btn-xs">Detail</button></router-link>
                                <button
                                    type="button"
                                    class="buttons btn-warning btn-xs"
                                    @click="sendId(data._id)"
                                    v-show="checkRole == 6 && data.video_status == 'new'"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                >
                                    CreateRoom
                                </button>
                                <button
                                    type="button"
                                    class="buttons btn-success btn-xs"
                                    @click="videoReview(data.video_link, data._id)"
                                    v-show="checkRole == 6 && data.video_status == 'scheduled'"
                                    data-toggle="modal"
                                    data-target="#joinRoom"
                                >
                                    JoinRoom
                                </button>
                            </td>

                            <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" id="exampleModalLabel">Create Room</h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <form>
                                                <div class="form-group">
                                                    <label>Masukkan Tanggal </label>
                                                    <input type="datetime-local" v-model="schedule" />
                                                </div>
                                            </form>
                                        </div>
                                        <div class="modal-footer">
                                            <div @click="createRoom(data.id_nasabah)" class="create-room">Create Room</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </tr>
                    </tbody>
                </table>
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="my-table"></b-pagination>
            </div>

            <div class="modal fade" id="joinRoom" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <!-- <h5 class="modal-title" id="exampleModalLabel">Create Room</h5> -->
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="leaveRoom">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <!-- <form @submit.prevent="blacklist"> -->
                        <div class="modal-body">
                            <div class="wrap-video" v-if="status == 200">
                                <div class="host">
                                    <div id="liveVideo"></div>
                                </div>
                                <div class="participant">
                                    <div id="participant"></div>
                                </div>
                            </div>
                            <div class="error btn-centering" v-else-if="status == 400">
                                <p>Link sudah kedaluarsah</p>
                                <div class="btn-primer btn-centering">Create Room</div>
                            </div>
                            <div class="error" v-else-if="status == 403">Mohon tunggu sampai tanggal yang sudah dijadwalkan</div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="leaveRoom" v-show="status == 200">Leave Room</button>
                        </div>
                        <!-- </form> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { connect, createLocalVideoTrack } from "twilio-video";

export default {
    data() {
        return {
            dataNsb: [],
            id: "",
            currentPage: 1,
            perPage: 5,
            number: 1,
            roomName: "",
            videoShow: false,
            localTrack: false,

            schedule: "",
            status: "",
            activeRoom: "",
            idRoom: "",
            dummy: "",
            // disconnect: false
        };
    },

    created() {
        axios.get("/v1/counter/get/list_nasabah?status=new").then((res) => {
            this.dataNsb = res.data.data;
        });
        window.addEventListener("beforeunload", this.leaveRoom);
    },
    methods: {
        createRoom(room_name) {
            axios
                .put("v1/counter/add_video", {
                    nasabah_id: this.id,
                    video_link: "Nasabah-" + room_name,
                    video_schedule: this.schedule,
                })
                .then((resp) => {
                    if (resp.data.status == 200) {
                        location.reload();
                    }
                });
        },
        sendId(id) {
            this.id = id;
        },

        connectTwilio(id, room_name) {
            axios.get(`v1/counter/get/twilio_token?identity=${id}`).then((res) => {
                let token = res.data.data.token;
                connect(token, { video: 350, name: room_name, recordParticipantsOnConnect: true }).then((room) => {
                    room.once("participantDisconnected", (participant) => {
                        room.disconnect();
                        var div = document.getElementById(participant.sid);
                        div.remove();
                    });
                    room.on("disconnected", (room) => {
                        // Detach the local media elements
                        room.localParticipant.tracks.forEach((publication) => {
                            publication.track.stop();
                            const attachedElements = publication.track.detach();
                            attachedElements.forEach((element) => element.remove());
                        });
                    });
                });
            });
        },
        leaveRoom() {
            this.status = 2;

            this.activeRoom.disconnect();
            this.roomName.stop();
            this.roomName.detach();
            document.getElementById("liveVideo").innerHTML = "";
            this.activeRoom.localParticipant.tracks.forEach((publication) => {
                document.getElementById("participant").innerHTML = "";
                const attachedElements = publication.track.detach();
                attachedElements.forEach((element) => element.remove());
            });
        },
        videoReview(room_name, id) {
            axios
                .get("v1/user/video/" + room_name)
                .then((resp) => {
                    if (resp.status == 200) {
                        this.status = resp.status;
                        var token;

                        axios.get(`v1/counter/get/twilio_token?identity=${id}`).then((resp) => {
                            token = resp.data.data.token;
                            document.getElementById("participant").innerHTML = "";
                            connect(token, { video: { width: 350 }, name: room_name }).then((room) => {
                                this.activeRoom = room;

                                createLocalVideoTrack().then((track) => {
                                    this.roomName = track;
                                    if (this.activeRoom.state != "disconnected") {
                                        const localMediaContainer = document.getElementById("liveVideo");
                                        localMediaContainer.appendChild(track.attach());
                                    } else {
                                        document.getElementById("liveVideo").innerHTML = "";
                                        track.stop();
                                    }
                                });

                                room.on("participantConnected", (participant) => {
                                    participant.tracks.forEach((publication) => {
                                        if (publication.isSubscribed) {
                                            const track = publication.track;
                                            document.getElementById("liveVideo").appendChild(track.attach());
                                        }
                                    });

                                    participant.on("trackSubscribed", (track) => {
                                        document.getElementById("liveVideo").appendChild(track.attach());
                                    });
                                });

                                room.participants.forEach((participant) => {
                                    participant.tracks.forEach((publication) => {
                                        if (publication.track) {
                                            document.getElementById("participant").appendChild(publication.track.attach());
                                        }
                                    });

                                    participant.on("trackSubscribed", (track) => {
                                        document.getElementById("participant").appendChild(track.attach());
                                    });
                                });

                                room.on("disconnected", (room) => {
                                    // Detach the local media elements
                                    room.localParticipant.tracks.forEach((publication) => {
                                        const attachedElements = publication.track.detach();
                                        attachedElements.forEach((element) => element.remove());
                                    });
                                });

                                // When a Participant removes a Track, detach it from the DOM.
                                room.on("trackRemoved", function(tracks) {
                                    tracks.forEach((track) => {
                                        track.detach().forEach((detachedElement) => {
                                            detachedElement.remove();
                                        });
                                    });
                                });
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.status = error.response.status;
                });
        },
    },
    computed: {
        checkRole() {
            let role = localStorage.getItem("role");
            if (role) {
                return role;
            } else {
                return null;
            }
        },
        rows() {
            return this.dataNsb.length;
        },
        paginate() {
            if (!this.dataNsb || this.dataNsb.length != this.dataNsb.length) {
                return;
            }
            var like = this;

            like.resultCount = this.dataNsb.length;
            if (this.currentPage >= this.totalPages) {
                like.currentPage = this.totalPages;
            }
            var index = this.currentPage * this.perPage - this.perPage;
            // console.log(index)
            // like.number = index
            return this.dataNsb.slice(index, index + this.perPage);
        },
    },
};
</script>

<style scoped>
.btn-centering {
    text-align: center;
    padding: 10px;
}

.btn-centering p {
    font-size: 20px;
}

.btn-primer {
    display: block;
    margin: 0 auto;
}

.wrap-video {
    display: flex;
}

.host {
    width: 49%;
    /* height: 200px; */
    /* border: 1px solid black */
}

/* #liveVideo video{
  max-width: 50%;
} */

.participant {
    width: 49%;
}

table {
    color: #707070 !important;
}

.create-room {
    cursor: pointer;
}

.nasabah {
    font-size: 14px;
    padding: 0 20px;
}

.title {
    font-size: 22px;
    font-weight: bold;
    margin: 0 0 60px;
}

.action {
    width: 186px;
}

video {
    width: 350px;
}
</style>
